import clsx from 'clsx'
import classes from './TowerIcon.module.css'

export default function TowerIcon({ className }: { className?: string }) {
  return (
    <>
      {/* <svg
        width="37"
        height="44"
        viewBox="0 0 37 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className)}
      >
        <path
          d="M30.3539 32.085V19.5723L33.1573 21.1908V30.4665L30.3539 32.085ZM26.5257 17.3621V34.2952L23.7226 35.9136V15.7438L26.5257 17.3621ZM17.091 38.1239V9.11304L3.82818 16.7704V13.5334L18.4926 5.06684L33.1573 13.5334V16.7704L19.8945 9.11304V38.1238L18.4926 38.9331L17.091 38.1239ZM13.2629 35.9136L10.4598 34.2952V17.3621L13.2629 15.7436V35.9136ZM3.82818 21.1908L6.6316 19.5723V32.085L3.82818 30.4665V21.1908ZM18.4926 0.646477L0 11.3232V32.6767L18.4926 43.3535L36.9855 32.6767V11.3232L18.4926 0.646477Z"
          fill="#703EFF"
        />
      </svg> */}

      <svg
        width="123"
        height="121"
        viewBox="0 0 123 121"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(classes.icon, className)}
      >
        <path
          d="M61.3789 0C95.2777 0 122.759 27.4811 122.759 61.3799C122.759 88.8789 104.674 112.153 79.75 119.962C78.4958 120.355 77.249 119.397 77.249 118.083V78.1019C77.249 77.378 77.6401 76.7106 78.2717 76.3569L86.3526 71.831C86.8676 71.5425 87.229 71.0412 87.3397 70.4614L89.5159 59.0706C89.7514 57.8378 88.8065 56.6953 87.5514 56.6953H34.3569C33.1018 56.6953 32.1569 57.8379 32.3925 59.0707L34.5693 70.4614C34.6801 71.0413 35.0415 71.5425 35.5565 71.831L43.6364 76.3559C44.268 76.7096 44.6592 77.377 44.6592 78.1009V117.809C44.6592 119.135 43.3909 120.094 42.1315 119.678C17.6613 111.604 0.000193393 88.5551 0 61.3799C0 27.4812 27.4803 0.000253611 61.3789 0ZM32.1063 39.7725C31.2263 39.7725 30.4497 40.3477 30.1932 41.1895L28.3204 47.335C27.9288 48.62 28.8901 49.918 30.2335 49.918H92.526C93.8695 49.918 94.8309 48.6199 94.4391 47.3348L92.5657 41.1893C92.3091 40.3476 91.5326 39.7725 90.6526 39.7725H32.1063Z"
          fill="currentColor"
        />
      </svg>
    </>
  )
}
